<template>
  <el-menu :default-active="defaultActive"
           class="el-menu-demo right"
           mode="horizontal"
           @select="handleSelect"
           :active="$route.matched[0].path"
           :router="true">
    <div class="app-nav">
      <div class="container"
           style="padding-top: 2px;
           padding-left: 0px;
           padding-right:0px;position: relative;"
           onclick="return false;">
        <img id="logo-name"
             @click="toIndex"
             src="../assets/logo-website.png"
             alt="logo" />
        <div v-bind:class="['menu-fr',{'no-login':!user['_id']}]">
          <el-menu-item class="menu-item"
                        v-if="user['_id']"
                        index="/mine">{{$t("tabNav.personal")}}</el-menu-item>
          <el-menu-item class="menu-item"
                        index="/api">{{$t("tabNav.api")}}</el-menu-item>
                        <!-- <a href="https://wiki.swarma.net/index.php/%E5%BD%A9%E4%BA%91%E5%B0%8F%E8%AF%91API" target="_bak"></a> -->
          <el-menu-item class="menu-item"
                        index="/fanyi">{{$t("tabNav.online")}}</el-menu-item>
          <el-dropdown @command="handleCommand"
                       class="avatar-container"
                       v-if="user['_id']"
                       trigger="click">
            <div class="avatar-wrapper">
              <img class="user-avatar"
                   :src="user['avatar']">
              <!--<i class="el-icon-caret-bottom"></i>-->
            </div>
            <el-dropdown-menu class="user-dropdown" 
                              slot="dropdown">
              <router-link class="inlineBlock" to="/mine/personal">
                <el-dropdown-item>{{$t("header.home")}}</el-dropdown-item>
              </router-link>
              <el-dropdown-item command="logout" divided>{{$t("header.SignOut")}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div class="menu-login"  v-if="!user['_id']">
            <button  type="button"
                     @click="showLoginDialog()"
                     class="btn btn-success">{{$t("header.register")}}</button>
          </div>
        </div>
      </div>
      <LoginModel ref="loginModel"></LoginModel>
    </div>
  </el-menu>
</template>
<style scoped>

  .menu-login{
    position: absolute;
    right: -6px;
    top: 28px;
    transform: translateY(-50%);
  }
  .menu-login >button{
    color: #fff;
    background-color: #5ebb8d;
    border-color: #4CA177;
    width: 90px;
    height: 30px;
    line-height:26px;

    border-radius: 2px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
  }
  .el-menu-item.is-active.no-active {
    color: #333;
  }
  .menu-login >button:hover{
    background-color: #4CA177;
  }
   @media (max-width: 650px) {
    .min-tabar{
        display: flex;
        flex-wrap: wrap;
    }
   }

 
</style>

<script>
  import { getUserData, logout,USER_INFO } from '@/api/user';
  import LoginModel from '../components/LoginModel';
  export default {
    name: "Navbar",
    components:{LoginModel},
    computed: {
      defaultActive() {
        return '/' + this.$route.path.split('/')[1];
      },
    },
    data() {
      return {
        avatarUrl: "",
        activeIndex: "",
        user:{},
        defaultActiveRoute:''
      };
    },
    mounted (){
      this.user = USER_INFO({});
    },
    methods: {
      handleSelect(key, keyPath) {
          if(key == '/api'){
            // window.open('//wiki.swarma.net/index.php/%E5%BD%A9%E4%BA%91%E5%B0%8F%E8%AF%91API');
          }else if(key == '/fanyi'){
            if(window.location.origin == 'http://localhost:8081'){
              window.location.href = 'http://localhost:8080/fanyi/';
            }else{
              window.location.href = window.location.origin+'/fanyi/';
            }
          }
      },
      handleCommand(command) {
        if (command === 'logout') {
          logout().then(responce => {
            window.location.href = '/'
          });
        }
      },
      toIndex() {
        if (window.location.href.indexOf("fanyi.caiyunapp.com") >= 0) {
          window.location.href = "//caiyunapp.com"
        } else {
          window.location.href = "/"
        }
      },
      showLoginDialog(){
        this.$refs.loginModel.show();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue